window.PinBoard = Block.extend({
    initialize: function(app, data, $dom, xml) {
        Block.prototype.initialize.call(this, app, data, $dom, xml);

        this.actionsManager = this.app.getComponent("ActionsManager");
        this.skillManager = this.app.getComponent("SkillsManager");

        this.skills = this.skillManager.getPinnedSkills();
        if(this.skills.length === 0) this.continue();
    },

    render: function() {
        var content = this.getContent(this.data);
        this.$el.html(content);

        this.addListener();

        OverviewAnimation.animateIn(this.$el.find(".overview"));
    },

    addListener: function() {
        var actionButton = new Button({
            el: this.$el.find(".action-button")
        });
        this.listenTo(actionButton, "onClick", this.handleActionButtonClick);

        this.$el.find(".plus-icon").each(function(i, item) {
            var plusButton = new Button({
                el: $(item)
            });
            this.listenTo(plusButton, "onClick", this.handlePlusIconClick);
        }.bind(this));
    },

    handleActionButtonClick: function() {
        this.complete();
        this.app.router.next();
    },

    handlePlusIconClick: function(e) {
        if(this.actionsManager.canAddAction()) {
            var id = $(e.currentTarget).attr("data-number");
            this.app.storage.setItem(ActionsManager.ACTION_DATA_KEY, {
                skillId: this.data.skills[id].pageId,
                title: this.data.skills[id].title,
                custom: this.data.skills[id].notes
            });

            this.app.router.changeGlobalSlide("actionform");
        } else {
            this.actionsManager.showMaxWarningDialog();
        }
    },

    continue: function() {
        this.complete();
        this.app.router.next();
    },

    getContent: function(data) {
        return Handlebars.templates["pinboard/pinboard"](data);
    },

    getData: function($xml, language) {
        var data = {};
        data.skills = [];
        data.title = this.blockData.title();
        data.content = LanguageManager.getString("pinned_content");
        data.myActionPlanLabel = LanguageManager.getString("my_action_plan");
        data.addToActionLabel = LanguageManager.getString("add_to_action");
        data.addedToActionLabel = LanguageManager.getString("added_to_action");

        _.each(this.skills, function(skill, i) {
            var action = this.actionsManager.getSkillAction(skill.getPageId());
            var item = {
                id: i,
                pageId: skill.getPageId(),
                category: skill.getCategory(),
                title: skill.getTitle(),
                rating: skill.getRating(),
                notes: skill.getNotes(),
                isPinned: true,
                isAdded: action != null
            };
            data.skills.push(item);
        }, this);
        return data;
    },

    handleSuspend: function() {
        Block.prototype.handleSuspend.call(this);

        this.stopListening(null, "onClick");
    },

    handleRestore: function() {
        Block.prototype.handleRestore.call(this);

        this.data = this.getData();
        this.render();
    }

}, {
    ACTION_DATA_KEY: "action_data_key"
});
